import {
  FundNoteRothConversion,
  MONEY_MARKET_EVENT_FEE,
  MONEY_MARKET_EVENT_GATE,
  MONEY_MARKET_EVENT_PERIOD_IN_EVENT,
  SystemCode,
} from 'src/settings/settings';
import {
  checkFoundFeaturesByCode,
  DISABLE_ON_MATCH,
  updateFundNote,
} from '../shared/shared-fund-notes-utility';

export function updateRothConversionFundNotesForFund(
  fund,
  sellOrExchangePendingFromTransactions,
  fundLockNotes
) {
  // If client has a fund that has a "Stop Transfer" service in effect (ServiceCode: 31)
  // "Stop Transfer" will be added to the notes section.
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(fund, SystemCode.STOP_TRANSFER_ID),
    FundNoteRothConversion.STOP_TRANSFER,
    DISABLE_ON_MATCH
  );

  //Blocking Retirement Income 2020 fund / Retirement Income 2020 fund - Iclass
  updateFundNote(
    fund,
    fund.fundName === 'Retirement Income 2020 Fund' ||
      fund.fundName === 'Retirement Income 2020 - I Class',
    FundNoteRothConversion.CONVERSION_RESTRICTED_RETIREMENT_2020,
    DISABLE_ON_MATCH
  );

  // Automated Systems Stop All
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(fund, SystemCode.AUTOMATED_SYSTEMS_STOP_ALL),
    FundNoteRothConversion.AUTOMATED_SYSTEMS_STOP_ALL,
    DISABLE_ON_MATCH
  );

  // If client has a fund that has a "Automated Systems Stop Redemption" service in effect (ServiceCode: 46)
  // "Unavailable Online" will be added to the notes section.
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(
      fund,
      SystemCode.AUTOMATED_SYSTEMS_STOP_REDEMPTION_ID
    ),
    FundNoteRothConversion.AUTOMATED_SYSTEMS_STOP_REDEMPTION,
    DISABLE_ON_MATCH
  );

  // If client has a fund with PendingTransactions that does not exceed redeemable funds
  // "transaction pending" will be added to the notes section.
  updateFundNote(
    fund,
    fund.hasPendingTransaction &&
      fund.redeemableFundDollars !== 0 &&
      fund.pendingTransactionAmount === null &&
      !sellOrExchangePendingFromTransactions.includes(fund.agreementNumber),
    FundNoteRothConversion.PENDING
  );

  // If client has a fund with PendingTransactions and the amount exceeds redeemable funds
  // "transaction pending" will be added to the notes section.
  updateFundNote(
    fund,
    fund.hasPendingTransaction && fund.redeemableFundDollars === 0,
    FundNoteRothConversion.PENDING_TRANSACTION,
    DISABLE_ON_MATCH
  );

  // if client has a pending transaction of either a sell or an exchange block them on the
  // "from" account from being able to do a roth-conversion
  updateFundNote(
    fund,
    fund.hasPendingTransaction &&
      fund.pendingTransactionAmount !== 0 &&
      fund.redeemableFundDollars !== 0 &&
      sellOrExchangePendingFromTransactions.includes(fund.agreementNumber),
    FundNoteRothConversion.PENDING_FROM_TRANSACTION,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fundLockNotes?.isIClass,
    FundNoteRothConversion.EXISTING_ICLASS,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fundLockNotes?.hasRothSameFundCode,
    FundNoteRothConversion.ROTH_RECENTLY_REDEEMED,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fundLockNotes?.hasRothSameFundCodeStopPurchase,
    FundNoteRothConversion.ROTH_STOP_PURCHASE,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fund.moneyMarketReformMessage &&
      fund.moneyMarketReformMessageType === MONEY_MARKET_EVENT_GATE &&
      fund.moneyMarketReformMessagePeriod ===
        MONEY_MARKET_EVENT_PERIOD_IN_EVENT,
    FundNoteRothConversion.MONEY_MARKET_EVENT_GATE_ACTIVE,
    DISABLE_ON_MATCH
  );

  updateFundNote(
    fund,
    fund.moneyMarketReformMessage &&
      fund.moneyMarketReformMessageType === MONEY_MARKET_EVENT_FEE &&
      fund.moneyMarketReformMessagePeriod ===
        MONEY_MARKET_EVENT_PERIOD_IN_EVENT,
    FundNoteRothConversion.MONEY_MARKET_EVENT_FEE_ACTIVE
  );

  updateFundNote(
    fund,
    fund.moneyMarketReformMessage &&
      fund.moneyMarketReformMessageType === MONEY_MARKET_EVENT_GATE &&
      fund.moneyMarketReformMessagePeriod !==
        MONEY_MARKET_EVENT_PERIOD_IN_EVENT,
    FundNoteRothConversion.MONEY_MARKET_EVENT_GATE_REMOVED
  );

  updateFundNote(
    fund,
    fund.moneyMarketReformMessage &&
      fund.moneyMarketReformMessageType === MONEY_MARKET_EVENT_FEE &&
      fund.moneyMarketReformMessagePeriod !==
        MONEY_MARKET_EVENT_PERIOD_IN_EVENT,
    FundNoteRothConversion.MONEY_MARKET_EVENT_FEE_REMOVED
  );
}
